import React from "react";
import { Checkbox as AntCheckbox, Form } from "antd";

import * as values from "values";
import { NumberField } from "Form/InputFields";
import { renderCheckboxes } from "Form/Checkbox";
import { MapAndLocation, Prices } from "Components/Filters/FilterComponents";
import { LandOffer, LandsFilter, FilterTypes } from "Types";
import FilterComponent from "./Filter";
import { OfferTypeNames } from "../../values";

const LandsFilterComponent = (): JSX.Element => {
    return (
        <FilterComponent<LandOffer, LandsFilter> type={FilterTypes.lands} label={OfferTypeNames.lands}>
            {(formik, filter): JSX.Element => (
                <>
                    <Form.Item label={"Typ pozemku"}>
                        <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                            {renderCheckboxes(values.availableLandTypes, "landTypes", formik)}
                        </AntCheckbox.Group>
                    </Form.Item>
                    <MapAndLocation formik={formik} filter={filter} />

                    <Prices />
                    <Form.Item label={"Velikost"}>
                        <div className={"rmxo-input-inline"}>
                            <div>
                                <NumberField name={"sizeTotalFrom"} placeholder={"Velikost od"} />
                            </div>
                            <div>
                                <NumberField name={"sizeTotalTo"} placeholder={"Velikost do"} />
                            </div>
                        </div>
                    </Form.Item>
                </>
            )}
        </FilterComponent>
    );
};

export default LandsFilterComponent;
